<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form
      class="past-departments-form"
      @submit.prevent="customPasses(onSubmit)">
      <fieldset :disabled="readonly">
        <template v-for="(pastDepartment, index) in form.pastDepartments">
          <div
            v-if="!readonly || pastDepartment.educationLevel !== null"
            :key="index"
            class="position-relative">
            <LinkButton
              v-if="!readonly"
              class="position-absolute"
              style="top: 0; right: 0;"
              type="button"
              @click="onRemovePastDepartment(index)">
              <RoundedIcon
                color="danger"
                icon="delete" />
            </LinkButton>
            <div style="max-width: 180px;">
              <BaseSelectGroupWithProvider
                v-model="form.pastDepartments[index].educationLevel"
                label="年代"
                rules="required"
                name="年代"
                :options="elementaryLevelOptions"
                :response-errors="apiErrors"
                :vid="`pastDepartments[${index}].educationLevel`" />
            </div>
            <BaseTextFieldGroupWithProvider
              v-model="form.pastDepartments[index].name"
              name="所属チーム名"
              label="所属チーム名"
              rules="required|max:20"
              :response-errors="apiErrors"
              :vid="`pastDepartments[${index}].name`" />
            <b-form-group
              v-if="readonly"
              label="ポジション・選抜・トレセンなどの経歴">
              <DisplayTextarea
                :content="form.pastDepartments[index].position" />
            </b-form-group>
            <BaseTextareaGroupWithProvider
              v-else
              v-model="form.pastDepartments[index].position"
              label="ポジション・選抜・トレセンなどの経歴"
              :response-errors="apiErrors"
              :vid="`pastDepartments[${index}].position`" />
            <hr
              v-if="!isLastIndex(index)"
              class="mt-4">
          </div>
        </template>
        <LinkButton
          v-if="!readonly"
          class="my-2"
          @click="onAddPastDepartment">
          <RoundedIcon
            class="mr-2"
            color="l-blue"
            icon="add" />
          記録する前所属・経歴を追加
        </LinkButton>
        <BaseErrorMessage
          v-if="apiErrors && apiErrors.nonFieldErrors"
          :errors="apiErrors.nonFieldErrors" />
      </fieldset>
      <div
        v-if="!readonly"
        class="d-flex justify-content-between mt-4"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-block btn-primary mt-0">
          保存
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import BaseSelectGroupWithProvider from '@/components/parts/BaseSelectGroupWithProvider.vue'
import BaseTextFieldGroupWithProvider from '@/components/parts/BaseTextFieldGroupWithProvider.vue'
import BaseTextareaGroupWithProvider from '@/components/parts/BaseTextareaGroupWithProvider.vue'
import DisplayTextarea from '@/components/parts/DisplayTextarea.vue'
import LinkButton from '@/components/parts/LinkButton.vue'
import RoundedIcon from '@/components/parts/RoundedIcon.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
import validateMixin from '@/components/mixin/validate'
export default {
  components: {
    BaseSelectGroupWithProvider,
    BaseTextFieldGroupWithProvider,
    BaseTextareaGroupWithProvider,
    DisplayTextarea,
    LinkButton,
    RoundedIcon,
    BaseErrorMessage
  },
  mixins: [validateMixin],
  props: {
    apiErrors: {
      type: Object,
      default: null
    },
    pastDepartments: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        pastDepartments: [
          {
            educationLevel: null,
            name: '',
            position: '',
          }
        ]
      }
    }
  },
  computed: {
    elementaryLevelOptions() {
      return [
        {
          value: null,
          text: '選択してください'
        },
        {
          value: 'elementary',
          text: '小学生'
        },
        {
          value: 'junior_high',
          text: '中学生'
        },
        {
          value: 'high_school',
          text: '高校生'
        },
        {
          value: 'university',
          text: '大学生'
        }
      ]
    }
  },
  watch: {
    apiErrors(val) {
      if (val) {
        this.$refs.observer.setErrors(val)
      }
    }
  },
  created() {
    this.setForm()
  },
  methods: {
    setForm() {
      if (this.pastDepartments.length === 0) {
        return
      }
      const pastDepartments = this.pastDepartments.map(pastDepartment => ({
        educationLevel: pastDepartment.educationLevel,
        name: pastDepartment.name,
        position: pastDepartment.position,
      }))
      this.form.pastDepartments = pastDepartments
    },
    isLastIndex(index) {
      return index === this.form.pastDepartments.length - 1
    },
    onSubmit() {
      const pastDepartments = this.form.pastDepartments
      this.$emit('submit', { pastDepartments })
    },
    onAddPastDepartment() {
      this.form.pastDepartments.push({
        educationLevel: null,
        name: '',
        position: '',
      })
    },
    async onRemovePastDepartment(index) {
      if (!window.confirm('この年代の所属・経歴を削除してもよろしいですか？')) return
      this.form.pastDepartments.splice(index, 1)
    },
    onClickCancel() {
      this.$router.back()
    }
  }
}
</script>

<style>

</style>